import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createEvent, listEvents, updateEvent, listHalloweenUsers, listHalloweenSpins, listHalloweenRewards } from './api';
import { EventFilters, EventInput, HalloweenUserFilters } from './types';

const key = ['events'] as const;

export function useEvents(filters: EventFilters, enabled = true) {
  return useQuery({ queryKey: [...key, filters], queryFn: () => listEvents(filters), enabled });
}

export function useHalloweenUsers(filters: HalloweenUserFilters) {
  return useQuery({ queryKey: [...key, 'halloween-2026', 'users', filters], queryFn: () => listHalloweenUsers(filters) });
}

export function useHalloweenSpins(userID: string, page: number, perPage: number, enabled: boolean) {
  return useQuery({ queryKey: [...key, 'halloween-2026', userID, 'spins', page, perPage], queryFn: () => listHalloweenSpins(userID, page, perPage), enabled });
}

export function useHalloweenRewards(userID: string, page: number, perPage: number, enabled: boolean) {
  return useQuery({ queryKey: [...key, 'halloween-2026', userID, 'rewards', page, perPage], queryFn: () => listHalloweenRewards(userID, page, perPage), enabled });
}

export function useSaveEvent() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input, slug }: { id?: number; input: EventInput; slug: string }) =>
      id === undefined ? createEvent({ ...input, slug }) : updateEvent(id, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: key }),
  });
}
